import { render, staticRenderFns } from "./PasswordComplexity.vue?vue&type=template&id=10ba4b79&scoped=true&"
import script from "./PasswordComplexity.vue?vue&type=script&lang=js&"
export * from "./PasswordComplexity.vue?vue&type=script&lang=js&"
import style0 from "./PasswordComplexity.vue?vue&type=style&index=0&id=10ba4b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba4b79",
  null
  
)

export default component.exports